<template>
  <q-btn
      v-bind="$attrs"
      class="btn btn__common btn__common--accent"
      :class="{'full-width': wide}"
      no-caps
      unelevated
  >
    <slot />
  </q-btn>
</template>

<script>
export default {
  props: {
    wide: {
      type: Boolean,
      default: false
    },
  }
}
</script>
